import React, { useState } from "react";
import { Button } from "@mui/material";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { InputMask } from "primereact/inputmask";
import { Modal } from "react-bootstrap"; // React‑Bootstrap Modal
import Swal from "sweetalert2"; // SweetAlert2 for popups

const SubscriptionTab = () => {
  // State for showing the modal
  const [showCardModal, setShowCardModal] = useState(false);
  // State for card details form inside the modal
  const [cardNumber, setCardNumber] = useState("");
  const [cardHolder, setCardHolder] = useState("");
  const [expiry, setExpiry] = useState(null);
  const [cvv, setCvv] = useState("");
  const [paymentErrors, setPaymentErrors] = useState({});

  // State for payment information displayed in the Payment Information section
  const [paymentInfo, setPaymentInfo] = useState({
    cardType: "visa",
    lastFour: "4242",
    expiry: "12/26",
  });

  // Sample invoice data; replace with dynamic data as needed
  const invoices = [
    { date: "Mar 15, 2025", amount: "$50.00", pdfLink: "#" },
    { date: "Feb 15, 2025", amount: "$50.00", pdfLink: "#" },
  ];

  // Handler when "Save" is clicked in the modal
  const handleCardUpdate = () => {
    let errorsObj = {};

    // Validate Card Number
    const cleanedNumber = cardNumber.replace(/\s/g, "");
    if (cardNumber.trim() === "") {
      errorsObj.cardNumber = "Card number is required.";
    } else if (cleanedNumber.length !== 16 || !/^\d+$/.test(cleanedNumber)) {
      errorsObj.cardNumber = "Please enter a valid 16-digit card number.";
    }

    // Validate Card Holder Name: only alphabets and spaces allowed.
    if (cardHolder.trim() === "") {
      errorsObj.cardHolder = "Card holder name is required.";
    } else if (!/^[A-Za-z\s]+$/.test(cardHolder.trim())) {
      errorsObj.cardHolder = "Card Holder Name must contain only alphabets and spaces.";
    }

    // Validate Expiry Date
    if (!expiry) {
      errorsObj.expiry = "Expiry date is required.";
    }

    // Validate CVV: Exactly 3 digits.
    if (cvv.trim() === "") {
      errorsObj.cvv = "CVV is required.";
    } else if (cvv.trim().length !== 3 || !/^\d+$/.test(cvv.trim())) {
      errorsObj.cvv = "Please enter a valid 3-digit CVV.";
    }

    if (Object.keys(errorsObj).length > 0) {
      setPaymentErrors(errorsObj);
      return; // Do not proceed if there are errors.
    }

    // If form is valid, clear errors.
    setPaymentErrors({});

    // Format expiry date if it's a Date object
    let expiryStr = paymentInfo.expiry;
    if (expiry instanceof Date) {
      const month = ("0" + (expiry.getMonth() + 1)).slice(-2);
      const year = expiry.getFullYear().toString().slice(-2);
      expiryStr = `${month}/${year}`;
    }

    // Update the payment info state with the new details.
    setPaymentInfo({ cardType: "visa", lastFour: cleanedNumber.slice(-4), expiry: expiryStr });

    Swal.fire({
                  width: 400,
                  heightAuto: false,
      icon: "success",
      title: '<h4 style="color:#407775;font-size: 20px;">Success!</h4>',
      html: "<p>Payment method updated successfully.</p>",
      iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
    });
    setShowCardModal(false);

    // Optionally, clear the form fields.
    setCardNumber("");
    setCardHolder("");
    setExpiry(null);
    setCvv("");
  };
  return (
    <div className="subscription-details-container profile-tabs">
      {/* Header: Title + Upgrade Plan */}
      <div className="subscription-header d-flex justify-content-between align-items-center">
        <h2 className="subscription-title">
          Subscription Details{" "}
          <span className="subscription-status">
            <span className="bullet">•</span> <span className="active-text">Active</span>
          </span>
        </h2>
        <Button variant="contained" className="upgrade-plan-btn">
          Upgrade Plan
        </Button>
      </div>

      {/* Plan Details */}
      <div className="plan-details row">
        <div className="col-md-3 col-sm-6 detail-box">
          <label>Current Plan</label>
          <p>CSRD Plan</p>
        </div>
        <div className="col-md-3 col-sm-6 detail-box">
          <label>Billing Cycle</label>
          <p>Monthly</p>
        </div>
        <div className="col-md-3 col-sm-6 detail-box">
          <label>Start Date</label>
          <p>Mar 15, 2025</p>
        </div>
        <div className="col-md-3 col-sm-6 detail-box">
          <label>Next Billing Date</label>
          <p>Apr 15, 2025</p>
        </div>
      </div>
      <hr className="divider" style={{ color: "#9ebab9", margin: "24px 0" }} />

      {/* Payment Information */}
      <div className="payment-section">
        <h3>Payment Information</h3>
        <div className="d-flex align-items-center gap-3">
          <img src="/assets/img/profile/visa.svg" alt="Visa" style={{ height: 20 }} />
          <span className="payment-method" style={{ fontSize: "14px!important" }}>
            •••• •••• •••• {paymentInfo.lastFour}
          </span>
          <span className="payment-expiry mb-0" style={{ color: "#9e9e9e" }}>
            expires {paymentInfo.expiry}
          </span>
        </div>
        <Button variant="outlined" className="update-payment-btn mt-3" onClick={() => setShowCardModal(true)}>
          Update payment method
        </Button>
      </div>

      {/* React‑Bootstrap Modal as the payment update popup */}
      <Modal show={showCardModal} onHide={() => setShowCardModal(false)} centered dialogClassName="custom-modal-width business-modal payment-modal">
        <Modal.Header closeButton>
          <div className="steps__containt-hader edit-form">
            <h3 className="title">Update Card Details</h3>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="edit-form">
            <div className="form-group">
              <label className="formlable">Card Number</label>
              <InputMask
                mask="9999 9999 9999 9999"
                placeholder="1234 5678 9012 3456"
                value={cardNumber}
                onChange={(e) => {
                  setCardNumber(e.value);
                  setPaymentErrors((prev) => ({ ...prev, cardNumber: "" }));
                }}
                className="form-control w-100"
              />
              {paymentErrors.cardNumber && (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {paymentErrors.cardNumber}
                </div>
              )}
            </div>
            <div className="form-group">
              <label className="p-mt-5 p-mb-3 formlable">Card Holder Name</label>
              <input
                value={cardHolder}
                onChange={(e) => {
                  const newValue = e.target.value;
                  if (newValue === "" || /^[A-Za-z\s]*$/.test(newValue)) {
                    setCardHolder(newValue);
                    setPaymentErrors((prev) => ({ ...prev, cardHolder: "" }));
                  }
                }}
                placeholder="John Doe"
                className="form-control w-100"
              />

              {paymentErrors.cardHolder && (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {paymentErrors.cardHolder}
                </div>
              )}
            </div>

            <div className="fomr-group row gx-5">
              <div className="col-md-6">
                <label className="formlable">Expiry</label>
                <Calendar
                  value={expiry}
                  onChange={(e) => {
                    setExpiry(e.value);
                    setPaymentErrors((prev) => ({ ...prev, expiry: "" }));
                  }}
                  view="month"
                  dateFormat="mm/yy"
                  placeholder="MM/YY"
                  showIcon
                  className="w-100"
                />
                {paymentErrors.expiry && (
                  <div className="invalid-feedback" style={{ display: "block" }}>
                    {paymentErrors.expiry}
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <label className="formlable">CVV</label>
                <InputMask
                  mask="999"
                  value={cvv}
                  onChange={(e) => {
                    setCvv(e.value);
                    setPaymentErrors((prev) => ({ ...prev, cvv: "" }));
                  }}
                  placeholder="123"
                  className="w-100 form-control"
                />
                {paymentErrors.cvv && (
                  <div className="invalid-feedback" style={{ display: "block" }}>
                    {paymentErrors.cvv}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="edit-form forms-buttons-container">
            <Button onClick={() => setShowCardModal(false)} className="outline-btn">
              Cancel
            </Button>
            <Button onClick={handleCardUpdate} className="next-button" style={{ color: "#fff!important" }}>
              Save
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <hr className="divider" style={{ color: "#9ebab9", margin: "24px 0" }} />

      {/* Invoice History */}
      <div className="invoice-history-section">
        <h3>Invoice History</h3>
        {invoices.map((inv, idx) => (
          <React.Fragment key={idx}>
            <div className="invoice-row d-flex align-items-center justify-content-between">
              <div>
                <div className="invoice-date">{inv.date}</div>
                <div className="invoice-number">Invoice # 15/03/2025150326</div>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <div className="invoice-amount">{inv.amount}</div>
                <a href={inv.pdfLink} target="_blank" rel="noreferrer" className="invoice-pdf">
                  <img src="/assets/img/profile/download.svg" style={{ height: "14px", marginRight: "8px" }} alt="PDF Icon" className="pdf-icon" />
                  PDF
                </a>
              </div>
            </div>
            <hr className="divider" style={{ color: "#9ebab9", margin: "16px 0" }} />
          </React.Fragment>
        ))}
      </div>

      {/* Cancel Subscription */}
      <div className="cancel-subscription">
        <Button variant="outlined">Cancel Subscription</Button>
      </div>
    </div>
  );
};

export default SubscriptionTab;
